
import './stores.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import user from '../../service/user';
import zone from '../../service/zone';
import store from '../../service/store';

import menuLayout from '../../directive/menu-layout';
import customTable from '../../directive/custom-table';

import routing from './stores.routes';
import StoresController from './stores.controller';

export default angular.module('page.stores', [
		uirouter,

		user,
		zone,
		store,

		menuLayout,
		customTable
	])
	.config(routing)
	.controller('StoresController', StoresController)
	.name;



// WEBPACK FOOTER //
// ./src/page/stores/index.js